<template>
  <div
    v-if="providerName"
    class="order-table-item-providers"
  >
    Anbieter:
    <template v-if="isTelekom">
      {{ providerName }}
    </template>
    <Modal
      v-else
      close-on-backdrop
      heading-text="Brodos AG"
    >
      <template #trigger="{ open }">
        <LinkButton
          tag="button"
          data-tealium-rel="content.text.hier"
          text
          no-styling
          @click="open"
          >{{ providerName }}</LinkButton
        >.
      </template>
      <BrodosInfoModal />
    </Modal>
  </div>
</template>

<script>
import BrodosInfoModal from '@/components/brodos-info-modal.vue';
import { LinkButton, Modal } from '@i22-td-smarthome/component-library';

const PROVIDER = {
  TELEKOM: 'Telekom Deutschland GmbH',
  BRODOS: 'Brodos AG',
};

export default {
  name: 'OrderTableItemProvider',
  components: {
    LinkButton,
    Modal,
    BrodosInfoModal,
  },
  props: {
    providerKey: {
      required: true,
      type: String,
    },
  },
  computed: {
    isTelekom() {
      return this.providerKey === 'TELEKOM';
    },
    providerName() {
      if (this.providerKey && PROVIDER[this.providerKey]) {
        return PROVIDER[this.providerKey];
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.order-table-item-providers {
  @include font-size(15px, 24px);
}
</style>
